import { Component, OnInit, OnDestroy, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { Platform, MenuController, NavController, LoadingController, AlertController, ModalController, ActionSheetController, PopoverController, ToastController, IonRouterOutlet } from '@ionic/angular';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Network } from '@ionic-native/network/ngx';
import { BaseService } from './services/base.service';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { BasePagePage } from './shared/base-page/base-page.page';
import { Constants } from './data-model/constant.model';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { Meta } from '@angular/platform-browser';
// import { FCM } from '@ionic-native/fcm/ngx';
// import { FirebaseX } from '@ionic-native/firebase-x/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent extends BasePagePage implements OnInit, OnDestroy, AfterViewInit {

  public appPages = [
    {
      title: 'Operator',
      url: '/operator',
      icon: 'people'
    },
    {
      title: 'Usage',
      url: '/usage',
      icon: 'stats'
    },
    {
      title: 'Impression',
      url: '/impression',
      icon: 'bulb'
    },
    {
      title: 'WIP',
      // url: '/wip',
      url: '/wip',
      icon: 'briefcase'
    },
    {
      title: 'Machine Output',
      // url: '/output',
      url: '/output',
      icon: 'construct'
    },
    {
      title: 'Logout',
      url: '/logout',
      icon: 'log-out'
    }
  ];

  isConnectionLost: boolean = false

  backButtonSubscription; // for storing the returned subscription

  selectedPath = '';

  versionNumber: string | number;

  // set up hardware back button event.
  lastTimeBackPress = 0;
  timePeriodToExit = 2000;

  @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;

  constructor(
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private platform: Platform,
    private statusBar: StatusBar,
    private service: BaseService,
    private network: Network,
    public navCtrl: NavController,
    public menuCtrl: MenuController,
    public modalCtrl: ModalController,
    private menu: MenuController,
    private actionSheetCtrl: ActionSheetController,
    private popoverCtrl: PopoverController,
    private router: Router,
    private toastCtrl: ToastController,
    private appVersion: AppVersion,
    private meta: Meta,
    // private fcm: FCM,
    // private firebaseX: FirebaseX
  ) {
    super(loadingCtrl, alertCtrl);
    this.initializeApp();

    // Initialize BackButton Eevent.
    // this.backButtonEvent();
  }

  initializeApp() {

    this.platform.ready().then(() => {

      if (this.service.isDesktop()) {

        // Debug
        const viewport = this.meta.getTag('name=version');
        this.versionNumber = viewport.content;
        // console.log("BROWSER: ", this.versionNumber);
        this.checkConsoleLog();

      } else {

        this.appVersion.getVersionNumber().then(
          (v) => {
            this.versionNumber = v;
            // console.log("VVVVVV: ", this.versionNumber);
            this.checkConsoleLog();
          },
          (err) => {
            // PWA
            const viewport = this.meta.getTag('name=version');
            this.versionNumber = viewport.content;
            // console.log("EEEEE: ", this.versionNumber);
            this.checkConsoleLog();
          }
        );

      }

      // // const plugin = (window as any).FirebasePlugin;
      // const plugin = (window as any).FCM;

      // plugin.getToken(function (fcmToken) {
      //   console.log('----------fcmToken: ', fcmToken);
      // }, function (error) {
      //   console.error(error);
      // });

      // plugin.subscribe("latest_news");

      // this.fcm.requestPushPermissionIOS().then(isOK => {
      //   console.log(`CAN PUSH IOS? ${isOK}`);
      // });

      // this.fcm.getAPNSToken().then(token => {
      //   console.log("APNtokentokentoken: ", token);
      // })

      // // subscribe to a topic
      // this.fcm.subscribeToTopic('latest_news');

      // // get FCM token
      // this.fcm.getToken().then(token => {
      //   console.log("tokentokentoken: ", token);
      // });

      // // ionic push notification example
      // this.fcm.onNotification().subscribe(data => {
      //   console.log(data);
      //   if (data.wasTapped) {
      //     console.log('Received in background');
      //   } else {
      //     console.log('Received in foreground');
      //   }
      // });

      // // refresh the FCM token
      // this.fcm.onTokenRefresh().subscribe(token => {
      //   console.log(token);
      // });

      // unsubscribe from a topic
      // this.fcm.unsubscribeFromTopic('offers');

      // this.firebaseX.grantPermission();

      // this.firebaseX.getToken()
      //   .then(token => console.log(`The token is ${token}`)) // save the token server-side and use it to push notifications to this device
      //   .catch(error => console.error('Error getting token', error));

      // this.firebaseX.onMessageReceived()
      //   .subscribe(data => console.log(`User opened a notification ${data}`));

      // this.firebaseX.onTokenRefresh()
      //   .subscribe((token: string) => console.log(`Got a new token ${token}`));

      // this.firebaseX.subscribe('latest_news');

    });

    this.router.events.subscribe(async (event: RouterEvent) => {
      if (event instanceof NavigationEnd) {

        this.selectedPath = event.url

        let arrPath = this.selectedPath.split('/');

        if (arrPath.length > 2) {

          this.backButtonSubscription = this.platform.backButton.subscribeWithPriority(1, () => {

            console.log('============= JUST NORMAL BACK');

            this.navCtrl.back();

          });

        } else {

          // console.log('alert: ', BasePagePage.alertController.getTop());

          try {
            const element = await this.actionSheetCtrl.getTop();
            if (element) {
              element.dismiss();
              return;
            }
          } catch (error) {
          }
    
          // close popover
          try {
            const element = await this.popoverCtrl.getTop();
            if (element) {
              element.dismiss();
              return;
            }
          } catch (error) {
          }
    
          // close modal
          try {
            const element = await this.modalCtrl.getTop();
            if (element) {
              element.dismiss();
              return;
            }
          } catch (error) {
            console.log(error);
    
          }
    
          // close side menua
          try {
            const element = await this.menu.getOpen();
            if (element) {
              this.menu.close();
              return;
    
            }
    
          } catch (error) {
    
          }

          this.backButtonSubscription = this.platform.backButton.subscribeWithPriority(1, () => {

            console.log('NO ALERT ============= EXIT APP, ', BasePagePage.alertController.getTop());

            // BasePagePage.presentAlert('Alert', 'Are you sure want to exit app?', (res) => {

            //   if (res.role == Constants.b_OK) {

            //     navigator['app'].exitApp();

            //   }

            // }, [Constants.b_CANCEL, Constants.b_OK]);

            if (new Date().getTime() - this.lastTimeBackPress < this.timePeriodToExit) {
              // this.platform.exitApp(); // Exit from app
              navigator['app'].exitApp(); // work in ionic 4
    
            } else {
              this.toastCtrl.create({
                message: 'Please click back again to exit',
                duration: this.timePeriodToExit,
                position: 'bottom'
              }).then((toastData) => {
                console.log(toastData);
                toastData.present();
              });
    
              this.lastTimeBackPress = new Date().getTime();
    
              console.log('LAST TIME BACK: ', this.lastTimeBackPress);
            }

          });

        }

      }

    });

    this.platform.ready().then(() => {
      // this.statusBar.styleDefault();
      this.statusBar.styleLightContent();
    });

    // disable backbutton hardware event action
    // this.platform.ready().then(() => {
    //   this.platform.backButton.subscribeWithPriority(9999, () => {
    //     document.addEventListener('backbutton', function (event) {
    //       event.preventDefault();
    //       event.stopPropagation();
    //     });
    //   });
    //   this.statusBar.styleDefault();
    // });

    // watch network for a connection
    let connectSubscription = this.network.onConnect().subscribe(() => {
      console.log('network connected!');
      // We just got a connection but we need to wait briefly
      // before we determine the connection type. Might need to wait.
      // prior to doing any api requests as well.
      if (this.isConnectionLost == true) {
        this.isConnectionLost = false
      }
      setTimeout(() => {
        if (this.network.type === 'wifi') {
          console.log('we got a wifi connection, woohoo!');
        }
      }, 3000);

    });

    // watch network for a disconnection
    let disconnectSubscription = this.network.onDisconnect().subscribe(() => {
      console.log('network was disconnected :-(');
      // this.baseService.presentAlert("Oppss..", "Network connection was lost. 😢");
      this.isConnectionLost = true
    });

  }

  // active hardware back button
  backButtonEvent() {
    this.platform.backButton.subscribe(async () => {
      console.log('BACK BUTTON HERE');
      // close action sheet
      try {
        const element = await this.actionSheetCtrl.getTop();
        if (element) {
          element.dismiss();
          return;
        }
      } catch (error) {
      }

      // close popover
      try {
        const element = await this.popoverCtrl.getTop();
        if (element) {
          element.dismiss();
          return;
        }
      } catch (error) {
      }

      // close modal
      try {
        const element = await this.modalCtrl.getTop();
        if (element) {
          element.dismiss();
          return;
        }
      } catch (error) {
        console.log(error);

      }

      // close side menua
      try {
        const element = await this.menu.getOpen();
        if (element) {
          this.menu.close();
          return;

        }

      } catch (error) {

      }

      console.log('routerOutletsrouterOutlets: ', this.routerOutlets);

      // var arr = this.appPages.filter(element => (element.url.replace('/', '')));
      const curr: Array<string> = this.router.url.split('/').filter(function (el) {
        return el != null && el != '';
      })
      console.log('currcurrcurr: ', curr);

      const outlet: any = this.routerOutlets.first;
      const activeView = outlet.activated.instance; // the active view instance          
      //now calls the onBackButtonPress function in that instance       
      console.log('cangoback: ', (outlet && outlet.canGoBack()));   
      console.log('arrrrrrrrtrrrrr: ', (curr.length == 1));  
      if (outlet && outlet.canGoBack()) {
        // activeView.onBackButtonPress();
        outlet.back();
      } else if (curr.length == 1) {
        //some logic about what to do if onBackButtonPress is not defined, default action
        if (new Date().getTime() - this.lastTimeBackPress < this.timePeriodToExit) {
          // this.platform.exitApp(); // Exit from app
          navigator['app'].exitApp(); // work in ionic 4

        } else {
          this.toastCtrl.create({
            message: 'Please click back again to exit',
            duration: this.timePeriodToExit,
            position: 'bottom'
          }).then((toastData) => {
            console.log(toastData);
            toastData.present();
          });

          this.lastTimeBackPress = new Date().getTime();

          console.log('LAST TIME BACK: ', this.lastTimeBackPress);
        }
      }


      // this.routerOutlets.forEach((outlet: IonRouterOutlet) => {
      //   if (outlet && outlet.canGoBack()) {
      //     // outlet.pop();
      //   } else if (this.router.url.split('/').length <= 2) {
      //     if (new Date().getTime() - this.lastTimeBackPress < this.timePeriodToExit) {
      //       // this.platform.exitApp(); // Exit from app
      //       navigator['app'].exitApp(); // work in ionic 4

      //     } else {
      //       this.toastCtrl.create({
      //         message: 'Please click back again to exit',
      //         duration: 2000,
      //         position: 'bottom'
      //       }).then((toastData) => {
      //         console.log(toastData);
      //         toastData.present();
      //       });
      //       // this.toastCtrl.create(
      //       //     `Press back again to exit App.`,
      //       //     '2000',
      //       //     'center')
      //       //     .subscribe(toast => {
      //       //         // console.log(JSON.stringify(toast));
      //       //     });
      //       this.lastTimeBackPress = new Date().getTime();

      //       console.log('LAST TIME BACK: ', this.lastTimeBackPress);
      //     }
      //   }
      // });
    });
  }

  ngOnInit() {
    // this.platform.ready().then(() => {
    //   navigator['app'].clearHistory();
    // });
  }

  ngAfterViewInit() {
    // this.subsribeHardwareBackButton();
  }

  ngOnDestroy() {
    // this.unsubsribeHardwareBackButton();
  }

  close() {
    console.log('CLOSE');
    this.menuCtrl.close('first');
  }

  checkConsoleLog() {
    if (this.versionNumber.toString().includes('.')) {
      const arrVersionNumber = this.versionNumber.toString().split('.');
      console.log('VERSION NUMBER: ', arrVersionNumber);
      if (arrVersionNumber.length < 4) {
        if (window) {
          window.console.log = function () { };
        }
      }
    }
  }

}
